<template>
  <div>
    <transition name="fade">
      <div id="menu" class="menu-box" v-if="isMenuActive">
        <div class="menu">
          <ul class="menu__list">
            <li class="menu__list__item">
              <router-link to="/les_couleurs">Les couleurs</router-link>
            </li>
            <li class="menu__list__item">
              <router-link to="/advertising_artist">Advertising,Artist</router-link>
            </li>
            <li class="menu__list__item">
              <router-link to="/movie_visual">Movie Visual</router-link>
            </li>
            <li class="menu__list__item">
              <router-link to="/profile">Profile</router-link>
            </li>
            <li class="menu__list__item">
              <router-link to="/works">WORKS</router-link>
            </li>
          </ul>
          <a href="mailto:t555555t2000@yahoo.co.jp" target="_blank" class="menu__contact">contact</a>
          <div class="menu__sns">
            <a href="https://www.facebook.com/profile.php?id=100005494710829" target="_blank" class="menu__sns__item">
              <img src="@/assets/icon/facebook.svg" width="50" height="50" alt="Facebook公式">
            </a>
            <a href="https://www.instagram.com/tomojirokamiya/" target="_blank" class="menu__sns__item">
              <img src="@/assets/icon/instagram.svg" width="50" height="50" alt="Instagram公式">
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
//
import { mapState } from 'vuex';
export default {
  name: 'Menu',
  computed: mapState(['isMenuActive'])
};
</script>

<style lang="scss" scoped>
// Vue トランジションアニメーションの設定
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.menu-box {
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: $black;

  @include mq-up() {
    padding: 130px 0 0;
  }

  @include mq-down() {
    padding: 65px 0 0;
  }
}

.menu {
  padding-bottom: 1.5em;
  text-align: center;

  &__list {
    &__item {
      @include mq-up() {
        @include fz(54);
      }

      @include mq-down() {
        @include fz(24);
        margin-top: 0.2em;
      }

      &:nth-last-of-type(1) {

        @include mq-up() {
          @include fz(40);
          margin-top: .25em;
        }

        @include mq-down() {
          @include fz(18);
          margin-top: 0.4em;
        }
      }

      a {
        color: $white;
        font-weight: $font-weight-bold;

        &:hover {
          opacity: 0.5;
          text-decoration: none;
        }
      }
    }
  }

  &__contact {
    display: inline-block;
    margin: 1.5em;
    padding: .5em 2em;
    color: $white;
    font-weight: $font-weight-bold;
    border: 1px solid $white;

    &:hover {
      opacity: 0.5;
      color: $white;
      text-decoration: none;
    }

    @include mq-up() {
      @include fz(36);
    }

    @include mq-down() {
      @include fz(18);
    }
  }

  &__sns {

    &__item {
      display: inline-block;

      @include mq-up() {
        width: 50px;
      }

      @include mq-down() {
        width: 40px;
      }

      &:hover {
        opacity: 0.5;
      }
    }

    &__item+&__item {
      margin-left: 1rem;
    }
  }
}

.title {
  margin: 0 0 0.6em;
  color: #808080;
  font-weight: normal;

  @include mq-up() {
    @include fz(100);
  }

  @include mq-down() {
    @include fz(44);
  }
}
</style>
